import React from "react";
import { Input, Icon, Popup } from "semantic-ui-react";
import { capitalize } from "utils/patientConverter";

const errorStyle = {
	color: "#dc0000",
	fontSize: "0.7em",
};

const label = {
	fontSize: "0.8em",
	marginTop: 5,
	marginLeft: 2,
};

const styles = {
	crossRequired: {
		color: "#c5190e",
		fontSize: "1em",
		position: "relative",
		bottom: 1,
		left: 3,
	},
};

const CustomInputTextWithAction = ({
	field,
	form: { touched, errors },
	forceUpperCase = false,
	forceCapitalize = false,
	iconName = "close",
	iconDisabled = false,
	onIconClick,
	...props
}) => {
	return (
		<div>
			<div style={label}>
				{props.customlabel}
				{props.required && <span style={styles.crossRequired}>*</span>}
			</div>

			<Input
				ref={props.innerref}
				{...field}
				{...props}
				fluid
				placeholder={props.placeholder}
				style={{ marginTop: 1 }}
				error={Boolean(touched[field.name] && errors[field.name])}
				required={props.required}
				className="inputText"
				autoCorrect="off"
				autoComplete="off"
				spellCheck="off"
				input={
					<input
						onInput={(e) => {
							if (forceUpperCase) e.target.value = ("" + e.target.value).toUpperCase();
							else if (forceCapitalize)
								e.target.value = e.target.value
									.split("-")
									.map((v) => capitalize(v))
									.join("-");
						}}
					/>
				}
				icon={{
					color: iconDisabled ? "grey" : "green",
					inverted: !iconDisabled,
					name: iconName,
					link: !iconDisabled,
					onClick: onIconClick,
					circular: true,
				}}
			/>

			{errors[field.name] && touched[field.name] && <div style={errorStyle}>{errors[field.name]}</div>}
		</div>
	);
};

export default CustomInputTextWithAction;
